import { SchemesEnum } from '@cryptoboyio/mercuryo-lab';

import { getSystemColorScheme, handleLocalStorage } from '@utils';
import { LanguageType } from '@utils/i18n';
import { LocationStateValues } from '@utils/types';

import type { GlobalTypes } from '@modules';
import { LoadersType } from '@modules/builders';

import { asyncActions } from './actions';

const { getItem } = handleLocalStorage;

export interface GlobalStateType {
  loaders: LoadersType<typeof asyncActions>;
  errors: {
    data?: Record<string, string>;
    message?: string;
  };
  currencies: GlobalTypes.Currencies;
  countries: GlobalTypes.Country[];
  states: GlobalTypes.States;
  dataByIp?: GlobalTypes.Country;
  ibanPurposes: GlobalTypes.IbanPurposes;
  captcha: string;
  isShowCaptcha: boolean;
  from?: string;
  calcId?: string;
  isUk?: boolean;
  to?: string;
  scheme: SchemesEnum;
  protect?: keyof typeof CONST.nav;
  fingerPrintData: Record<string, string>;
  lang?: LanguageType;
  zhModalType?: GlobalTypes.ZHModalTypeEnum;
  redirect: {
    to?: keyof typeof CONST.nav;
    search?: string;
    state?: LocationStateValues;
  };
}

const scheme = getItem('scheme') || getSystemColorScheme() || CONST.defaultScheme;
const lang = getItem('i18nextLng');

export const initialState: GlobalStateType = {
  loaders: {},
  errors: {},
  countries: [],
  states: [],
  ibanPurposes: [],
  currencies: {
    fiat: [],
    crypto: [],
    config: {
      display_options: {},
      icons: {},
      base: {},
      has_withdrawal_fee: {},
      default_networks: {},
    },
  },
  captcha: '',
  isUk: false,
  isShowCaptcha: false,
  scheme,
  fingerPrintData: {},
  lang,
  redirect: {},
};

export default initialState;
